import { createContext } from 'react';
import { BpmFormBuilderProps } from '../BpmFormBuilderProps';

export const bpmFormBuilderContext = createContext<React.ComponentType<BpmFormBuilderProps> | null>(null);
